import {
  PORTAINER_EDGE_GROUP_VARIABLE,
  PORTAINER_EDGE_ID_VARIABLE,
} from '../../types';

export function hasDynamicVariable(path: string): boolean {
  return (
    path.includes(PORTAINER_EDGE_GROUP_VARIABLE) ||
    path.includes(PORTAINER_EDGE_ID_VARIABLE)
  );
}

export function renderStyledPath(path: string) {
  // Split the path by dynamic variables and render with styling
  const parts = path
    .split(/(\$\{PORTAINER_EDGE_GROUP\}|\$\{PORTAINER_EDGE_ID\})/g)
    .filter(Boolean);

  return (
    <div className="text-muted mt-1 font-mono text-xs">
      {parts.map((part, index) => {
        if (
          part === PORTAINER_EDGE_GROUP_VARIABLE ||
          part === PORTAINER_EDGE_ID_VARIABLE
        ) {
          return (
            <span
              key={index}
              className="bg-primary-5 text-primary rounded px-1 py-0.5"
              style={{ backgroundColor: 'rgba(59, 130, 246, 0.1)' }}
            >
              {part}
            </span>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </div>
  );
}
